import type { ScheduleAvailability } from "@tabipla/shared/types";
import { AvailabilityIcon } from "./AvailabilityIcon";

interface ResponseButtonProps {
  status: ScheduleAvailability;
  isSelected: boolean;
  onClick: () => void;
}

export function ResponseButton({ status, isSelected, onClick }: ResponseButtonProps) {
  const baseClass =
    "flex h-8 w-8 items-center justify-center rounded-lg border-2 transition-all active:scale-95";
  const selectedClass = {
    available: "border-green-500 bg-green-50 dark:bg-green-950/30",
    maybe: "border-yellow-500 bg-yellow-50 dark:bg-yellow-950/30",
    unavailable: "border-red-500 bg-red-50 dark:bg-red-950/30",
  };
  const unselectedClass = "border-muted hover:border-muted-foreground/50";

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${baseClass} ${isSelected ? selectedClass[status] : unselectedClass}`}
    >
      <AvailabilityIcon status={status} className="h-4 w-4" />
    </button>
  );
}
